// ── Ten or Nothing: the tactical console. Brushed steel over a blueprint
//    that carries the 0–10 scale the whole game turns on. ──

import Table3D from './Table3D';

const Blueprint = () => (
  // Le carte coprono il centro del tavolo: il contenuto che conta sta nelle
  // due fasce che restano scoperte, sopra e sotto.
  <svg viewBox="0 0 400 260" preserveAspectRatio="none" style={{ width: '100%', height: '100%', opacity: 0.95 }}>
    <defs>
      <linearGradient id="ton-scale" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#38bdf8" />
        <stop offset="12%" stopColor="#ef4444" />
        <stop offset="26%" stopColor="#22c55e" />
        <stop offset="74%" stopColor="#22c55e" />
        <stop offset="88%" stopColor="#ef4444" />
        <stop offset="100%" stopColor="#38bdf8" />
      </linearGradient>
    </defs>

    {/* reticolo di fondo */}
    {Array.from({ length: 9 }, (_, i) => (
      <line key={`v${i}`} x1={40 * i + 20} y1="0" x2={40 * i + 20} y2="260" stroke="#5b9bff" strokeWidth="0.6" opacity="0.22" />
    ))}
    {Array.from({ length: 6 }, (_, i) => (
      <line key={`h${i}`} x1="0" y1={44 * i + 14} x2="400" y2={44 * i + 14} stroke="#5b9bff" strokeWidth="0.6" opacity="0.22" />
    ))}

    {/* fascia alta: linea di circuito */}
    <g opacity="0.85">
      <path d="M14 20 L96 20 L108 12 L188 12" fill="none" stroke="#7fb0ff" strokeWidth="1.2" opacity="0.6" />
      <path d="M212 12 L292 12 L304 20 L386 20" fill="none" stroke="#7fb0ff" strokeWidth="1.2" opacity="0.6" />
      {[14, 96, 188, 212, 304, 386].map((x, i) => (
        <rect key={i} x={x - 3} y={(i === 2 || i === 3) ? 9 : 17} width="6" height="6" rx="1.5" fill="#7fb0ff" opacity="0.7" />
      ))}
      <text x="200" y="17" textAnchor="middle" fontSize="11" letterSpacing="4"
        fill="#9ecbff" fontFamily="monospace" opacity="0.75">0 — 10</text>
    </g>

    {/* fascia bassa: la scala su cui si gioca */}
    <g>
      <rect x="30" y="236" width="340" height="7" rx="3.5" fill="url(#ton-scale)" opacity="0.95" />
      {Array.from({ length: 11 }, (_, i) => {
        const x = 30 + i * 34;
        const edge = i === 0 || i === 10;
        return (
          <g key={i}>
            <line x1={x} y1="232" x2={x} y2={edge ? 222 : 228} stroke={edge ? '#f87171' : '#9ecbff'} strokeWidth={edge ? 1.8 : 1} opacity="0.9" />
            <text x={x} y="218" textAnchor="middle" fontSize="12" fontFamily="monospace"
              fill={edge ? '#f87171' : '#9ecbff'} opacity={edge ? 0.95 : 0.6}>{i}</text>
          </g>
        );
      })}
      <text x="30" y="255" textAnchor="start" fontSize="8" letterSpacing="2" fill="#f87171" fontFamily="monospace" opacity="0.8">FUORI</text>
      <text x="370" y="255" textAnchor="end" fontSize="8" letterSpacing="2" fill="#f87171" fontFamily="monospace" opacity="0.8">FUORI</text>
    </g>
  </svg>
);

const TonTable = ({ children, mobile = false, active = false }) => (
  <Table3D
    mobile={mobile}
    active={active}
    grain={90}
    surface={{ top: '#1b2a45', mid: '#0d1729', low: '#152341', deep: '#060c18' }}
    trim={{
      rim: 'rgba(110,155,215,0.8)', rivet: '#9dc0e6', ink: '#0a2148',
      accent: '#60a5fa', glow: 'rgba(59,130,246,0.2)',
    }}
    inlay={<Blueprint />}
  >
    {children}
  </Table3D>
);

export default TonTable;
